import axios from "axios/index";
import store from '../stores/store';
import _ from "lodash";
import moment from "moment";

class SecurePaymentService {
    constructor() {
        this.requestHeaders = {
            "Authorization": "",
            "x-api-key": "",
            "Accept": "application/json"
        };
    }

    getRequestHeaders() {
        const state = store.getState();
        this.requestHeaders = {
            "Authorization": state.AuthReducer.userAccessToken,
            "x-api-key": state.AppReducer.applicationConfig.support_anyware_api_key
        };

        return this.requestHeaders;
    }

    getFloodGateRequestHeaders() {
        const state = store.getState();
        return {
            "Authorization": state.AuthReducer.userAccessToken,
            "x-api-key": state.AppReducer.applicationConfig.client_id,
            'x-gw-ims-org-id':'9E1005A551ED61CA0A490D45@AdobeOrg',
            'x-sandbox-name':state.AppReducer.applicationConfig.floodgate_api_sandbox_name
        };
    }
    getAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.support_anyware_api_url + "/products_support/customers/memos?api_key=" + state.AppReducer.applicationConfig.support_anyware_api_key;
    }

    getCommerceAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.commerce_api_url;
    }

    getFloodGateAPIbaseUrl() {
        const state = store.getState();
        return state.AppReducer.applicationConfig.floodgate_api_url;
    }

    updateToken(tokenDetails) {
        const state = store.getState();
        let tokenUrl = this.getAPIbaseUrl() + '&userId=' + state.AuthReducer.userInfo.userId;
        if(state.UserInfoReducer.termsConditionAccepted){
            tokenUrl = tokenUrl+'&termsAccepted=true'
        }
        return axios({
            url: tokenUrl,
            method: 'post',
            headers: this.getRequestHeaders(),
            data: tokenDetails
        });
    }
    
    loadStateList(countryCode) {
        const state = store.getState();
        return axios(
            {
                url: this.getCommerceAPIbaseUrl()+'/countries/'+countryCode,
                method: 'get',
                headers: {
                    'x-api-key': state.AppReducer.applicationConfig.client_id
                }
            }
        )
    }

    async loadTermsCondition(product,index){
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.ims_terms_condition_url+"?client_id="+state.AppReducer.applicationConfig.client_id+"&service_name="+product.tncTemplateName+"&locale="+state.LocaleReducer.value;
        const response = await axios.get(urlData);
        return {
            templateName: product.tncTemplateName,
            tc: response.data,
            selected:false,
            productName: product.productName,
            id:index
        };
    }


    async getEventTermCondition() {
        const fromDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const toDate = moment().format('YYYY-MM-DD');
        let eventDataLocal = [];
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.support_anyware_api_url+"/sales_services/customers/event/logger?rowCount=15&event_type=ORDER_PLACEMENT_TNC&customer_guid="+state.AuthReducer.userInfo.userId+"&fromDate="+fromDate+"&toDate="+toDate;
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
            if(response.data && response.data.responseData && response.data.responseData.length){
                //--start--- Filtering USED events from the event list 
                let eventList = response.data.responseData.filter(item => _.has(item,'STATUS') && item.STATUS === 'USED' ? false: true );
                eventList = _.orderBy(eventList, ['INSERT_TIMESTAMP'], ['desc']);
                // ---END---

                eventList.forEach(obj => {
                    obj.METADATA = obj.METADATA ? JSON.parse(obj.METADATA) : {};
                    obj.METADATA.PRODUCT_ITEMS = obj.METADATA.PRODUCT_ITEMS ? JSON.parse(obj.METADATA.PRODUCT_ITEMS) : [];
                });
                if(eventList[0].METADATA["PRODUCT_ITEMS"] && eventList[0].METADATA["PRODUCT_ITEMS"].length){
                    const list = eventList[0].METADATA["PRODUCT_ITEMS"].map((product,index) => this.loadTermsCondition(product,index))
                    eventDataLocal = await Promise.all(list);
                }
            }
        } catch(error) {
            console.log(error)
        }
        return eventDataLocal;
    }

    async getEventLogTermCondition(){
        let eventDataLocal = [];
        const state = store.getState();
        const urlData = state.AppReducer.applicationConfig.hendrix_api_url+"/communication/message/fetch/"+state.AuthReducer.userInfo.email+'?messagetype=ORDER_PLACEMENT_TNC';
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
           
            if(response && response.data && response.data.message){
                response.data.message = response.data.message ? JSON.parse(response.data.message) : {};
                response.data.message.PRODUCT_ITEMS = response.data.message.PRODUCT_ITEMS ? response.data.message.PRODUCT_ITEMS : [];
                const list = response.data.message.PRODUCT_ITEMS.map((product,index) => this.loadTermsCondition(product,index))
                eventDataLocal = await Promise.all(list);
            }
        } catch(error) {
            console.log(error);
            throw new Error(error);
        }
        return eventDataLocal;
    }

    async getEventMiniWallet() {
        let eventDataLocal = {};
        const state = store.getState();
        const email = state.AuthReducer.userInfo.email
        const urlData = state.AppReducer.applicationConfig.hendrix_api_url+"/communication/message/fetch/"+email+'?messagetype=CUSTOMER_DETAILS_WALLET_APP';
        try {
            const response = await axios.get(urlData,{
                headers: this.getRequestHeaders(),
            });
            if(response.data){
                response.data.message = response.data.message ? JSON.parse(response.data.message) : {};
                eventDataLocal = response.data;  
            }
        } catch(error) {
            console.log(error)
        }
        return eventDataLocal
    }

    loadFeatureFlag() {
        const state = store.getState();
        return axios({
            url: this.getFloodGateAPIbaseUrl()+"/feature?clientId=" + state.AppReducer.applicationConfig.client_id + "&meta=true",
            method: 'get',
            headers: {
                ...this.getFloodGateRequestHeaders(),
                'Content-Type': "application/json"
            }
        });
    }
}
const securePaymentService = new SecurePaymentService();
export default securePaymentService;
